import { createClassModuleFactory } from "../../ui/factories/module-factory-helpers.js";

const authModuleLoader = () => import('./AuthModule.js');
const authModuleFactory = createClassModuleFactory(authModuleLoader, 'AuthModule');

export const routes = [

    // AuthModule.ROUTE_LOGIN
    { name: 'auth-login', path: '/auth/login', factory: authModuleFactory, public: true },
    // AuthModule.ROUTE_LOGOUT
    { name: 'auth-logout', path: '/auth/logout', factory: authModuleFactory },

];
